module.exports = __webpack_public_path__ + "media/images/emblems/Les_Breuleux-coat_of_arms-a2497a85e24f1c8c9b70ab1c3cdfd9f2.svg";